export const cEl = tag => {
    return document.createElement(tag);
};

export const setToken = token => {
    window.localStorage.setItem(process.env.APP_TOKEN_KEY, token);
};

export const removeToken = () => {
    window.localStorage.removeItem(process.env.APP_TOKEN_KEY);
};

export const getToken = () => {
    return window.localStorage.getItem(process.env.APP_TOKEN_KEY);
};
